import classNames from "classnames";

const Content = ({ label, value, classNameValue }) => {
  return (
    <div className="text-gray-700 text-sm">
      {label} :{" "}
      <span className={classNames(`font-bold ${classNameValue}`)}>{value}</span>
    </div>
  );
};

export default Content;
